module.exports = __webpack_public_path__ + "static/media/user-friendly.df70abbd.svg";